function GATSocket(options) {
    this.url = options.url
    this.components = options.components
    this.messages = options.messages

    this.components_map = {}
    this.socket = null
    this.is_connection = false
    this.count = 1
    this.interval = 2000

    this.initSocket()
}

GATSocket.prototype.initSocket = function () {
    try {
        if (this.socket) {
            this.socket.close()
            this.socket = null
        }
    } catch (e) {
        console.log(e)
    }

    this.socket = new WebSocket(this.url)
    this.addListener(this.socket)

    this.components && this.components.forEach(function (component) {
        this.components_map[component.type] = component.handle
    }.bind(this))
}

GATSocket.prototype.addListener = function (ws) {
    var self = this
    ws.onopen = function () {
        try {
            self.messages && self.messages.forEach(function (message) {
                ws.send(JSON.stringify(message))
            })
        } catch (e) {
            console.log(e)
        }
    }

    ws.onmessage = function (e) {
        self.is_connection = true
        var data = JSON.parse(e.data)
        if (data.type) {
            var handle = self.components_map[data.type]
            handle && handle(data)
        }
    }

    ws.onclose = function (event) {
        if (!event.wasClean) {
            self.is_connection = false
            self.reconnection()
        } else {
            ws = null
        }
    }

    ws.onerror = function (event) {
        console.log('error', event)
    }
}

GATSocket.prototype.reconnection = function () {
    var self = this
    setTimeout(function () {
        if (!self.is_connection) {
            if (self.count > 30) return
            self.initSocket()
            self.reconnection()
            self.count++
        } else {
            self.count = 1
        }
    }, parseInt(self.count / 5) * self.interval + self.interval)
}

GATSocket.prototype.close = function () {
    this.socket.close()
}
// 注意此方法会替换掉已经存在的同type类型
GATSocket.prototype.addComponents = function (components) {
    components && components.forEach(function (component) {
        this.components_map[component.type] = component.handle
    }.bind(this))
}

// 传入的是字符串
GATSocket.prototype.removeComponents = function (components) {
    components && components.forEach(function (component) {
        this.components_map[component] = undefined
    }.bind(this))
}

export default GATSocket